// extracted by mini-css-extract-plugin
export default {"FullParent":"App_FullParent__b4zAy","Page":"App_Page__hG7Xu","SkillSectionLayout":"App_SkillSectionLayout__aGJNt","CVSection":"App_CVSection__kiYhu","root":"App_root__MXJt2"};